"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var _IndividualDetailEdit_personalDetails_accessor_storage, _IndividualDetailEdit_physicalCharacteristics_accessor_storage, _IndividualDetailEdit_contactInformation_accessor_storage, _IndividualDetailEdit_identification_accessor_storage, _IndividualDetailEdit_genderList_accessor_storage, _IndividualDetailEdit_raceList_accessor_storage, _IndividualDetailEdit_eyeColorList_accessor_storage, _IndividualDetailEdit_hairColorList_accessor_storage, _IndividualDetailEdit_stateList_accessor_storage, _IndividualDetailEdit_subTitle_accessor_storage;
Object.defineProperty(exports, "__esModule", { value: true });
exports.IndividualDetailEdit = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
const individual_details_util_1 = require("@app/util/individual-details-util");
const individual_details_styles_1 = require("./individual-details-styles");
const task_1 = require("@lit/task");
const lookup_client_1 = require("@app/client/lookup-client");
let IndividualDetailEdit = class IndividualDetailEdit extends lit_1.LitElement {
    constructor() {
        super(...arguments);
        _IndividualDetailEdit_personalDetails_accessor_storage.set(this, individual_details_util_1.IndividualDetailsUtil.getEmptyPersonalInformation());
        _IndividualDetailEdit_physicalCharacteristics_accessor_storage.set(this, individual_details_util_1.IndividualDetailsUtil.getEmptyPhysicalCharacteristics());
        _IndividualDetailEdit_contactInformation_accessor_storage.set(this, individual_details_util_1.IndividualDetailsUtil.getEmptyContactInformation());
        _IndividualDetailEdit_identification_accessor_storage.set(this, individual_details_util_1.IndividualDetailsUtil.getEmptyIdentification());
        _IndividualDetailEdit_genderList_accessor_storage.set(this, []);
        _IndividualDetailEdit_raceList_accessor_storage.set(this, []);
        _IndividualDetailEdit_eyeColorList_accessor_storage.set(this, []);
        _IndividualDetailEdit_hairColorList_accessor_storage.set(this, []);
        _IndividualDetailEdit_stateList_accessor_storage.set(this, []);
        _IndividualDetailEdit_subTitle_accessor_storage.set(this, '');
        Object.defineProperty(this, "getLookupData", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: new task_1.Task(this, {
                task: async () => {
                    const lookUpClient = new lookup_client_1.LookupClient();
                    const [genders, races, eyeColors, hairColors, states] = await Promise.all([
                        lookUpClient.getGenderList(),
                        lookUpClient.getRaceList(),
                        lookUpClient.getEyeColorList(),
                        lookUpClient.getHairColorList(),
                        lookUpClient.getStateList(),
                    ]);
                    this.genderList = genders;
                    this.raceList = races;
                    this.eyeColorList = eyeColors;
                    this.hairColorList = hairColors;
                    this.stateList = states;
                    this.requestUpdate();
                },
            })
        });
    }
    get personalDetails() { return __classPrivateFieldGet(this, _IndividualDetailEdit_personalDetails_accessor_storage, "f"); }
    set personalDetails(value) { __classPrivateFieldSet(this, _IndividualDetailEdit_personalDetails_accessor_storage, value, "f"); }
    get physicalCharacteristics() { return __classPrivateFieldGet(this, _IndividualDetailEdit_physicalCharacteristics_accessor_storage, "f"); }
    set physicalCharacteristics(value) { __classPrivateFieldSet(this, _IndividualDetailEdit_physicalCharacteristics_accessor_storage, value, "f"); }
    get contactInformation() { return __classPrivateFieldGet(this, _IndividualDetailEdit_contactInformation_accessor_storage, "f"); }
    set contactInformation(value) { __classPrivateFieldSet(this, _IndividualDetailEdit_contactInformation_accessor_storage, value, "f"); }
    get identification() { return __classPrivateFieldGet(this, _IndividualDetailEdit_identification_accessor_storage, "f"); }
    set identification(value) { __classPrivateFieldSet(this, _IndividualDetailEdit_identification_accessor_storage, value, "f"); }
    get genderList() { return __classPrivateFieldGet(this, _IndividualDetailEdit_genderList_accessor_storage, "f"); }
    set genderList(value) { __classPrivateFieldSet(this, _IndividualDetailEdit_genderList_accessor_storage, value, "f"); }
    get raceList() { return __classPrivateFieldGet(this, _IndividualDetailEdit_raceList_accessor_storage, "f"); }
    set raceList(value) { __classPrivateFieldSet(this, _IndividualDetailEdit_raceList_accessor_storage, value, "f"); }
    get eyeColorList() { return __classPrivateFieldGet(this, _IndividualDetailEdit_eyeColorList_accessor_storage, "f"); }
    set eyeColorList(value) { __classPrivateFieldSet(this, _IndividualDetailEdit_eyeColorList_accessor_storage, value, "f"); }
    get hairColorList() { return __classPrivateFieldGet(this, _IndividualDetailEdit_hairColorList_accessor_storage, "f"); }
    set hairColorList(value) { __classPrivateFieldSet(this, _IndividualDetailEdit_hairColorList_accessor_storage, value, "f"); }
    get stateList() { return __classPrivateFieldGet(this, _IndividualDetailEdit_stateList_accessor_storage, "f"); }
    set stateList(value) { __classPrivateFieldSet(this, _IndividualDetailEdit_stateList_accessor_storage, value, "f"); }
    get subTitle() { return __classPrivateFieldGet(this, _IndividualDetailEdit_subTitle_accessor_storage, "f"); }
    set subTitle(value) { __classPrivateFieldSet(this, _IndividualDetailEdit_subTitle_accessor_storage, value, "f"); }
    connectedCallback() {
        super.connectedCallback();
        this.getLookupData.run();
    }
    handleFirstNameChange(event) {
        const input = event.target;
        this.personalDetails.firstName = input.value;
        this.sendEditedDetailsEvent();
    }
    handleMiddleNameChange(event) {
        const input = event.target;
        this.personalDetails.middleName = input.value;
        this.sendEditedDetailsEvent();
    }
    handleLastNameChange(event) {
        const input = event.target;
        this.personalDetails.lastName = input.value;
        this.sendEditedDetailsEvent();
    }
    handleDobChange(event) {
        const input = event.target;
        this.personalDetails.birthDate = input.value;
        this.sendEditedDetailsEvent();
    }
    handleGenderChange(event) {
        this.personalDetails.gender = event.detail;
        this.sendEditedDetailsEvent();
    }
    handleHeightChange(event) {
        const input = event.target;
        this.physicalCharacteristics.height = input.value;
        this.sendEditedDetailsEvent();
    }
    handleWeightChange(event) {
        const input = event.target;
        this.physicalCharacteristics.weight = input.value;
        this.sendEditedDetailsEvent();
    }
    handleAddressChange(event) {
        const input = event.target;
        this.contactInformation.address = input.value;
        this.sendEditedDetailsEvent();
    }
    handleAddress2Change(event) {
        const input = event.target;
        this.contactInformation.address2 = input.value;
        this.sendEditedDetailsEvent();
    }
    handleCityChange(event) {
        const input = event.target;
        this.contactInformation.city = input.value;
        this.sendEditedDetailsEvent();
    }
    handleZipChange(event) {
        const input = event.target;
        this.contactInformation.zip = input.value;
        this.sendEditedDetailsEvent();
    }
    handlePhoneNumberChange(event) {
        const input = event.target;
        this.contactInformation.phoneNumber = input.value;
        this.sendEditedDetailsEvent();
    }
    handleEyeColorChange(event) {
        this.physicalCharacteristics.eyeColor = event.detail;
        this.sendEditedDetailsEvent();
    }
    handleHairColorChange(event) {
        this.physicalCharacteristics.hairColor = event.detail;
        this.sendEditedDetailsEvent();
    }
    handleStateChange(event) {
        this.contactInformation.state = event.detail;
        this.sendEditedDetailsEvent();
    }
    handleSsnChange(event) {
        const input = event.target;
        const value = input.value.replace(/\D/g, '').slice(0, 9);
        this.identification.ssn = value.replace(/(\d{3})(\d{2})(\d{0,4})/, (_, p1, p2, p3) => {
            return `${p1}-${p2}${p3 ? '-' + p3 : ''}`;
        });
        this.sendEditedDetailsEvent();
    }
    handleSIDChange(event) {
        const input = event.target;
        this.identification.sidNumber = input.value;
        this.sendEditedDetailsEvent();
    }
    handleDLChange(event) {
        const input = event.target;
        this.identification.dlNumber = input.value;
        this.sendEditedDetailsEvent();
    }
    handleFBIChange(event) {
        const input = event.target;
        this.identification.fbiNumber = input.value;
        this.sendEditedDetailsEvent();
    }
    sendEditedDetailsEvent() {
        this.dispatchEvent(new CustomEvent('individualEditDetails', {
            detail: {
                personalDetails: this.personalDetails,
                physicalCharacteristics: this.physicalCharacteristics,
                contactInformation: this.contactInformation,
                identification: this.identification,
            },
            bubbles: true,
            composed: true,
        }));
        this.requestUpdate();
    }
    render() {
        return (0, lit_1.html) `
      <div class="forge-card-header-container">
        <forge-label class="card-subtitle">PERSONAL INFORMATION</forge-label>
      </div>
      <div class="detail-content-edit-container">
        <forge-text-field show-clear="true">
          <forge-label>First name</forge-label>
          <input type="text" @input=${this.handleFirstNameChange} autocomplete="given-name" .value=${this.personalDetails.firstName} aria-label="First name"/>
        </forge-text-field>
        <forge-text-field show-clear="true"">
          <forge-label>Middle name</forge-label>
          <input type="text" @input=${this.handleMiddleNameChange} autocomplete="additional-name" .value=${this.personalDetails.middleName} aria-label="Middle name"/>
        </forge-text-field>
        <forge-text-field show-clear="true">
          <forge-label>Last name</forge-label>
          <input type="text" @input=${this.handleLastNameChange} autocomplete="family-name" .value=${this.personalDetails.lastName} aria-label="Last name"/>
        </forge-text-field>
        <forge-date-picker>
          <forge-text-field>
            <label for="dob-picker">DOB</label>
            <input type="text" @input=${this.handleDobChange}  id="dob-picker" autocomplete="off" .value=${this.personalDetails.birthDate} />
          </forge-text-field>
        </forge-date-picker>
        <sup-lookup-select .lookupList=${this.genderList} .label=${'Gender'} @onLookupSelectChangeEvent=${this.handleGenderChange} .selectValue=${this.personalDetails.gender.toString()} .required=${!this.personalDetails.gender} .theme=${this.personalDetails ? 'default' : 'error'}></sup-lookup-select>
      </div>
      <div class="forge-card-header-container">
        <forge-label class="card-subtitle">PHYSICAL CHARCTERISTICS</forge-label>
      </div>
      <div class="detail-content-edit-container">
        <forge-text-field show-clear="true">
          <forge-label>Height</forge-label>
          <input type="text" @input=${this.handleHeightChange} autocomplete="off" .value=${this.physicalCharacteristics.height} aria-label="Height"/>
        </forge-text-field>
        <forge-text-field show-clear="true">
          <forge-label>Weight</forge-label>
          <input type="text" @input=${this.handleWeightChange} autocomplete="off" .value=${this.physicalCharacteristics.weight} aria-label="Height"/>
        </forge-text-field>
        <sup-lookup-select .lookupList=${this.eyeColorList} .label=${'Eye color'} @onLookupSelectChangeEvent=${this.handleEyeColorChange} .selectValue=${this.physicalCharacteristics.eyeColor.toString()}></sup-lookup-select>
        <sup-lookup-select .lookupList=${this.hairColorList} .label=${'Hair color'} @onLookupSelectChangeEvent=${this.handleHairColorChange} .selectValue=${this.physicalCharacteristics.hairColor.toString()}></sup-lookup-select>
      </div>
      <div class="detail-content-review-container">
        <forge-label class="card-subtitle">CONTACT INFORMATION</forge-label>
      </div>
      <div class="detail-content-edit-address-container">
        <forge-text-field class="detail-content-edit-address-field" show-clear="true">
          <forge-label>Street address</forge-label>
          <input type="text" @input=${this.handleAddressChange} autocomplete="off" .value=${this.contactInformation.address} aria-label="Address"/>
        </forge-text-field>
        <forge-text-field class="detail-content-edit-address-field" show-clear="true">
          <forge-label>Street address 2 (optional)</forge-label>
          <input type="text" @input=${this.handleAddress2Change} autocomplete="off" aria-label="Address"/>
        </forge-text-field>
      </div>
      <div class="detail-content-edit-container">
        <forge-text-field show-clear="true">
          <forge-label>City</forge-label>
          <input type="text" @input=${this.handleCityChange} autocomplete="off" .value=${this.contactInformation.city} aria-label="City"/>
        </forge-text-field>
        <sup-lookup-select .lookupList=${this.stateList} .label=${'State'} @onLookupSelectChangeEvent=${this.handleStateChange} .selectValue=${this.contactInformation.state.toString()}></sup-lookup-select>
        <forge-text-field show-clear="true">
          <forge-label>Zip code</forge-label>
          <input type="text" @input=${this.handleZipChange} autocomplete="off" .value=${this.contactInformation.zip} aria-label="Zip code"/>
        </forge-text-field>
        <forge-text-field show-clear="true">
          <forge-label>Phone number</forge-label>
          <input type="text" @input=${this.handlePhoneNumberChange} autocomplete="off" .value=${this.contactInformation.phoneNumber} aria-label="Phone number"/>
        </forge-text-field>
      </div>
      <div class="forge-card-header-container">
        <forge-label class="card-subtitle">IDENTIFICATIONS</forge-label>
      </div>
      <div class="detail-content-edit-container">
        <forge-text-field show-clear="true">
          <forge-label>Social security number</forge-label>
          <input type="text" pattern="\\d{3}-\\d{2}-\\d{4}" placeholder="___-__-____" @input=${this.handleSsnChange} autocomplete="off" .value=${individual_details_util_1.IndividualDetailsUtil.getFormatSnn(this.identification.ssn)} aria-label="Social security number"/>
        </forge-text-field>
        <forge-text-field show-clear="true"">
        <forge-label>SID number</forge-label>
        <input type="text" @input=${this.handleSIDChange} autocomplete="off" .value=${this.identification.sidNumber} aria-label="SID number"/>
        </forge-text-field>
        <forge-text-field show-clear="true">
          <forge-label>Drivers license</forge-label>
          <input type="text" @input=${this.handleDLChange} autocomplete="off" .value=${this.identification.dlNumber} aria-label="Drivers license"/>
        </forge-text-field>
        <forge-text-field show-clear="true">
          <forge-label>FBI number</forge-label>
          <input type="text" @input=${this.handleFBIChange} autocomplete="off" .value=${this.identification.fbiNumber} aria-label="FBI number"/>
        </forge-text-field>
      </div>
    `;
    }
};
exports.IndividualDetailEdit = IndividualDetailEdit;
_IndividualDetailEdit_personalDetails_accessor_storage = new WeakMap();
_IndividualDetailEdit_physicalCharacteristics_accessor_storage = new WeakMap();
_IndividualDetailEdit_contactInformation_accessor_storage = new WeakMap();
_IndividualDetailEdit_identification_accessor_storage = new WeakMap();
_IndividualDetailEdit_genderList_accessor_storage = new WeakMap();
_IndividualDetailEdit_raceList_accessor_storage = new WeakMap();
_IndividualDetailEdit_eyeColorList_accessor_storage = new WeakMap();
_IndividualDetailEdit_hairColorList_accessor_storage = new WeakMap();
_IndividualDetailEdit_stateList_accessor_storage = new WeakMap();
_IndividualDetailEdit_subTitle_accessor_storage = new WeakMap();
Object.defineProperty(IndividualDetailEdit, "styles", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: [individual_details_styles_1.individualDetailStyles]
});
__decorate([
    (0, decorators_js_1.property)({ type: Object })
], IndividualDetailEdit.prototype, "personalDetails", null);
__decorate([
    (0, decorators_js_1.property)({ type: Object })
], IndividualDetailEdit.prototype, "physicalCharacteristics", null);
__decorate([
    (0, decorators_js_1.property)({ type: Object })
], IndividualDetailEdit.prototype, "contactInformation", null);
__decorate([
    (0, decorators_js_1.property)({ type: Object })
], IndividualDetailEdit.prototype, "identification", null);
__decorate([
    (0, decorators_js_1.property)({ type: Array })
], IndividualDetailEdit.prototype, "genderList", null);
__decorate([
    (0, decorators_js_1.property)({ type: Array })
], IndividualDetailEdit.prototype, "raceList", null);
__decorate([
    (0, decorators_js_1.property)({ type: Array })
], IndividualDetailEdit.prototype, "eyeColorList", null);
__decorate([
    (0, decorators_js_1.property)({ type: Array })
], IndividualDetailEdit.prototype, "hairColorList", null);
__decorate([
    (0, decorators_js_1.property)({ type: Array })
], IndividualDetailEdit.prototype, "stateList", null);
__decorate([
    (0, decorators_js_1.property)({ type: String })
], IndividualDetailEdit.prototype, "subTitle", null);
exports.IndividualDetailEdit = IndividualDetailEdit = __decorate([
    (0, decorators_js_1.customElement)('sup-individual-detail-edit')
], IndividualDetailEdit);
